import { ReactComponent as IconComment } from "../../../styles/assets/svg/icon_close.svg";

interface ModalProps {
  title: string;
  onClose: () => void;
  onRow?: boolean;
  children?: React.ReactNode;
}

export const slideUpStyle = `
@keyframes slideUp {
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}
`;

export const ModalBottom = ({
  onClose,
  title,
  onRow,
  children,
}: ModalProps) => {
  return (
    <>
      <style>{slideUpStyle}</style>
      <div
        style={{
          width: "100vw",
          maxWidth: "45rem",
          margin: "0 auto",
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.3)",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          zIndex: 1000,
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: "fixed",
          left: "50%",
          bottom: 0,
          zIndex: 1001,
          width: "100%",
          maxWidth: "45rem",
          background: "white",
          borderRadius: 16,
          borderEndStartRadius: 0,
          borderEndEndRadius: 0,
          padding: 16,
          display: "flex",
          flexDirection: "column",
          gap: 16,
          fontSize: 20,
          transform: "translate(-50%, 100%)",
          animation: "slideUp 0.3s ease-out forwards",
        }}
      >
        {onRow === true && (
          <div
            style={{
              position: "absolute",
              left: 0,
              bottom: 164, // 중앙 row 위치
              height: 48,
              width: "100%",
              background: "rgba(251,217,132,0.4)",
              borderRadius: 7,
              pointerEvents: "none",
            }}
          />
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <div style={{ fontWeight: 700 }}>{title}</div>
          <div style={{ position: "absolute", right: 0, cursor: "pointer" }}>
            <IconComment width={14} height={14} onClick={onClose} />
          </div>
        </div>

        {children}
      </div>
    </>
  );
};
